import axiosInstance from './axiosInstance';
import { Blog, BlogSummary } from '../types/blogs';

const API_URL = `${process.env.REACT_APP_API_URL}/public/blogs`;

export interface PaginatedBlogSummaries {
  content: BlogSummary[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export const getPublishedBlogs = (page: number, size: number) => {
  return axiosInstance.get<PaginatedBlogSummaries>(API_URL, {
    params: { page, size },
  });
};

export const getPublishedBlogBySlug = (slug: string) => {
  return axiosInstance.get<Blog>(`${API_URL}/${slug}`);
};
